<div *ngIf="!!idStr" [attr.role]="isCustomSectionHeaderRequired ? 'heading' : null"
  [attr.aria-level]="isCustomSectionHeaderRequired ? headingLevel : null" class="accordion-button-wrapper">
  <button #button [attr.aria-controls]="idStr" [attr.id]="idStr + '-button'"
    [attr.aria-expanded]="isOpen ? true : false" class="category accordionControlButton"
    (click)="sectionClicked.emit(sectionIndex)" type="button" [ngClass]="{ 'disabled': disabled }"
    [attr.aria-disabled]="disabled" [ngClass]="{'is-expanded': isExpanded}" >
    <!--if overwrite flag is off (default behavior), show the section title -->
    <ng-container *ngIf="!isCustomSectionHeaderRequired">
      <span [attr.id]="idStr + '-label'" *ngIf="sectionTitle" class="category-title hold-still"
        [innerHtml]="sectionTitle"></span>
    </ng-container>
    <ng-container *ngIf="isCustomSectionHeaderRequired">
      <!--if overwrite flag is on, display the ngcontent passed into the component-->
      <ng-content select="[sectionHeader]"></ng-content>
    </ng-container>
  </button>
</div>

<!-- expandable area-->
<div class="accordionSubMenu" [attr.id]="idStr">
  <div class="row">
    <div class="col-xs-12">
      <ng-content></ng-content>
    </div>
  </div>
</div>

<ng-content select="[footer]"></ng-content>
